/*
  This file has been mostly generated by AI (~80% by line count)
*/

import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/illustrations')({
  component: () => <Outlet />
})
